import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "experience-list" }
const _hoisted_2 = { class: "item-header" }
const _hoisted_3 = { class: "item-info" }
const _hoisted_4 = { class: "item-name" }
const _hoisted_5 = { class: "item-subname" }
const _hoisted_6 = { class: "item-date" }

import { content } from "@/content/data";

export default /*@__PURE__*/_defineComponent({
  __name: 'Education',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "section-title" }, "Education", -1)),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(content).education, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "bulleted-item"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.degree), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.college), 1)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.duration), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})